<!--
 * @Author: heroDHB
 * @Date: 2020-07-30 10:57:43
-->
<template>
  <div class="common-video">
    <img class="text" :src="textImg" />
    <img class="decorator" src="../../assets/imgs/home/video-decorator.jpg" />
    <div class="video-container" @click="handleOpen">
      <img class="video-bg" src="../../assets/imgs/home/video-bg.png" />
      <img class="video" :src="videoImg" />
      <img class="play" src="../../assets/imgs/home/play.png" />
      <div class="text">{{ bottomText }}</div>
    </div>
    <v-main>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        eager
        scrollable
      >
        <v-card tile>
          <v-toolbar style="flex-grow: 0" dark color="#032251">
            <v-btn icon @click="handleClose">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title>{{ bottomText }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="d-flex align-center" style="padding: 0">
            <video
              ref="videoEle"
              class="installVideo"
              :poster="videoPoster"
              controls="controls"
              width="100%"
              :src="videoSrc"
            ></video>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>
  </div>
</template>

<script>
export default {
  name: 'CommonVideo',
  props: ['textImg', 'videoImg', 'videoPoster', 'videoSrc', 'bottomText'],
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    handleClose() {
      this.dialog = false;
      this.$refs.videoEle.pause();
    },
    showVideo() {
      this.videoVisible = true;
    },
    handleOpen() {
      this.dialog = true;
      this.$refs.videoEle.play();
    },
  },
};
</script>

<style lang="less" scoped>
.common-video {
  margin-top: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .text {
    height: 34px;
  }
  .decorator {
    width: 750px;
    height: 38px;
  }
  .video-container {
    position: relative;
    margin-top: 49px;
    .video-bg {
      width: 631px;
      height: 424px;
    }
    .video {
      width: 450px;
      height: 270px;
      position: absolute;
      left: 116px;
      top: 50px;
      z-index: 1;
    }
    .play {
      position: absolute;
      left: 240px;
      top: 120px;
      z-index: 2;
      width: 150px;
      height: 150px;
    }
    .text {
      position: absolute;
      left: 50%;
      bottom: 24px;
      transform: translateX(-50%);
      z-index: 1;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: rgba(2, 239, 236, 1);
    }
  }
}
</style>
